import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigningLawSectionRadioComponent } from './signing-law-section-radio.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SigningLawSectionRadioComponent],
  exports: [SigningLawSectionRadioComponent],
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class SigningLawSectionRadioModule {}
